import reduceReducers from "reduce-reducers";

import { ECONTRACT_AGREEMENT } from "constants/actionTypes";

import {
  apiModelOfflineCreateReducer,
  apiModelOfflineFetchReducer,
} from "lib/reducers";
import { deserializeEContractAgreement } from "lib/serializers/eContractAgreements";
import { deserializeEContract } from "lib/serializers/eContracts";

const create = apiModelOfflineCreateReducer(ECONTRACT_AGREEMENT, {
  deserializer: deserializeEContractAgreement,
});

const fetch = apiModelOfflineFetchReducer(ECONTRACT_AGREEMENT, {
  deserializer: deserializeEContractAgreement,
  clearOnRequest: false,
});

function agreementGenerateReducer(state, action) {
  switch (action.type) {
    case ECONTRACT_AGREEMENT.GENERATE.SUCCESS: {
      const data: EContractAgreement[] = action.payload.map(p =>
        deserializeEContractAgreement(p),
      );
      const createdData = data.reduce(
        (acc: Record<string, EContractAgreement>, cur: EContractAgreement) => {
          acc[cur.id] = cur;
          return acc;
        },
        {},
      );
      return {
        ...state,
        byId: { ...state.byId, ...createdData },
      };
    }
    default:
      return state;
  }
}

// When generate_contract succeeds, the server returns an EContract (not an EContractAgreement).
// We don't mutate agreement state here — the eContracts reducer handles its own slice.
// We do need to update the agreement's econtract_ids list from the success payload's agreement_id.
function agreementGenerateContractReducer(state, action) {
  switch (action.type) {
    case ECONTRACT_AGREEMENT.GENERATE_CONTRACT.SUCCESS: {
      const econtract: EContract = deserializeEContract(action.payload);
      if (!econtract.agreementId) {
        return state;
      }
      const agreement = (state.byId as Record<string, EContractAgreement>)[
        econtract.agreementId
      ];
      if (!agreement) {
        return state;
      }
      const alreadyLinked = agreement.econtractIds?.includes(econtract.id);
      if (alreadyLinked) {
        return state;
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [agreement.id]: {
            ...agreement,
            econtractIds: [...(agreement.econtractIds ?? []), econtract.id],
          },
        },
      };
    }
    default:
      return state;
  }
}

const EContractAgreementsReducer = reduceReducers(
  create,
  fetch,
  agreementGenerateReducer,
  agreementGenerateContractReducer,
);

export default EContractAgreementsReducer;
